import { render, staticRenderFns } from "./PrivacyPolicyImprove.vue?vue&type=template&id=265a13de&scoped=true"
import script from "./PrivacyPolicyImprove.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyImprove.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyImprove.vue?vue&type=style&index=0&id=265a13de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265a13de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
